import { RokezzzPathService } from 'src/app/rokezzz/locale/services/path.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pathPipe',
    standalone: true
})
export class PathPipe implements PipeTransform {
    public constructor(
        private readonly rokezzzPathService: RokezzzPathService
    ) { }

    public transform(value: string | undefined): string | undefined {
        return this.rokezzzPathService.getPath(value);
    }
}
